<template>
  <div class="form">
    <div class="form__header">
      <h3>Добавить задание классу</h3>
    </div>
    <div class="form__body">
      <p class="form__field">
        Выберите шаблон или создайте новое
      </p>

      <p class="form__field">
        <span class="template-btn" @click="showTemplates = !showTemplates; template = null">Выбрать шаблон</span>
      </p> 

      <div v-show="showTemplates">
        <p class="form__checkbox">
          <input type="checkbox" v-model="templatesByClass" id="by-class">
          <label for="by-class">Фильтровать по классу</label>
        </p>
        <p class="form__field" v-show="showTemplates">
          <span>Шаблоны: </span>
          <v-select 
            label="title" 
            :options="templateList" 
            v-model="template" 
          >
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.title }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.title }}
              </div>
            </template>
          </v-select>                
        </p>
      </div>
      <p class="form__field" v-if="template">
        <HomeworkItem 
          :class_students="classItem.students" 
          :item="template" 
          :is_template="true"
        />
      </p>
    </div>

    <div class="form__footer">
      <button 
        type="button" 
        class="uk-button uk-button-primary" 
        @click="submit"
      >
        {{ template ? 'Создать из шаблона' : 'Создать новое' }}
      </button>      
    </div> 
  </div>
</template>

<script>
import HomeworkItem from './HomeworkItem.vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
export default {
  components: { HomeworkItem, vSelect },
  props: ['classItem'],
  data() {
    return {
      template: null,
      showTemplates: false,
      templatesByClass: false
    }
  },
  computed: {
    ...mapGetters({
      templates: 'teacher/templates'
    }),
    templateList() {
      if (this.templatesByClass) {
        return this.templates.filter(item => item.class_id === this.classItem.id)
      } else {
        return this.templates
      }
    },
    newClassLesson() {
      return { 
        id: new Date().getTime(),
        class_id: this.classItem.id,
        dates: [new Date().toLocaleDateString('ru-RU')],
        is_dynamical: false,
        is_template: false,
        trainers: [],
        is_new: true
      }
    }
  },
  methods: {
    submit() {
      let classLesson = {}
      if (this.template) {
        let studentIds = this.classItem.students.map(s => s.id)

        classLesson = _.cloneDeep(this.template)
        classLesson.dates = [new Date().toLocaleDateString('ru-RU')]
        classLesson.is_new = true
        classLesson.is_template = false 
        classLesson.class_id = this.classItem.id 
        
        // Фильтр учеников в шаблоне по текущему классу
        classLesson.trainers.forEach(item => {
          item.students = item.students.filter(s => studentIds.includes(s))
        })
      } else {
        classLesson = this.newClassLesson
      }
      console.log(classLesson)
      this.$emit('add-lesson-block', classLesson)
      this.$emit('close-popup')
    }
  }
}
</script>

<style lang="scss" scoped>
.template-btn {
  color: #0080DA;
  font-size: 16px;
  align-self: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>